import {
  SplitFactoryProvider,
  SplitTreatments,
} from '@splitsoftware/splitio-react';
import { ISplitTreatmentsChildProps } from '@splitsoftware/splitio-react/types/types';

const authorizationKey = window.LUCID_SPA_CONFIG?.SPLIT_IO_BROWSER_API_KEY;

export const SplitProvider = ({ children }: { children: any }) => {
  const sdkConfig: SplitIO.IBrowserSettings = {
    core: {
      authorizationKey,
      // key represents your internal user id, or the account id that
      // the user belongs to.
      // This could also be a cookie you generate for anonymous users.
      key: 'anonymous',
    },
  };

  return (
    <SplitFactoryProvider config={sdkConfig}>{children}</SplitFactoryProvider>
  );
};

export const FeatureFlag = ({
  featureName,
  when,
  children,
  attributes,
}: {
  featureName: string;
  when: string;
  children: any;
  attributes?: SplitIO.Attributes;
}) => {
  function renderContent({ treatments, isReady }: ISplitTreatmentsChildProps) {
    const { treatment } = treatments[featureName];
    if (treatment !== when || !isReady) return null;
    return children;
  }

  return (
    <SplitTreatments names={[featureName]} attributes={attributes}>
      {renderContent}
    </SplitTreatments>
  );
};
